import { getStatsPath } from '@app/modules/StatsDashboard/paths'
import { StatsPage } from '@app/modules/StatsDashboard/StatsPage'
import { IRoute } from '@app/Router/IRoute'

export const routes: IRoute[] = [
  {
    path: getStatsPath(),
    component: StatsPage,
    exact: true
  }
]
